import axios from "axios";

const state = {
    mensaje: ""
};


const mutations = {
    setMensaje: (state, mensaje) => {
        state.mensaje = mensaje;
    },
};

const actions = {
    async exportar({commit}, data) {
        try {
            let resp = await axios.post(`/v1/exportar/${data.entidad}/filtro`, data.filtro, {responseType: "arraybuffer"});

            if (resp?.data) {
                commit("setMensaje", "Descarga exitosa");
                return resp?.data
            } else {
                commit("setMensaje", "Descarga fallida");
                return null;
            }
        } catch (error) {
            return error;
        }
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
